import { useCallback } from "react";
import { useRefCache } from "@react-md/utils";
/**
 * This small utility function will create an onKeyDown handler that allows the
 * user to "click" an element with the keyboard via Enter or Space.
 */
export default function useKeyboardClickPolyfill(_a) {
    var _b = _a === void 0 ? {} : _a, onKeyDown = _b.onKeyDown, _c = _b.disabled, disabled = _c === void 0 ? false : _c, _d = _b.disableEnterClick, disableEnterClick = _d === void 0 ? false : _d, _e = _b.disableSpacebarClick, disableSpacebarClick = _e === void 0 ? false : _e;
    var ref = useRefCache({
        onKeyDown: onKeyDown,
        disableSpacebarClick: disableSpacebarClick,
        disableEnterClick: disableEnterClick,
    });
    var handleKeyDown = useCallback(function (event) {
        var _a = ref.current, onKeyDown = _a.onKeyDown, disableSpacebarClick = _a.disableSpacebarClick, disableEnterClick = _a.disableEnterClick;
        if (onKeyDown) {
            onKeyDown(event);
        }
        var isSpace = event.key === " ";
        var isEnter = event.key === "Enter";
        var currentTarget = event.currentTarget;
        var tagName = currentTarget.tagName;
        if ((!isSpace && !isEnter) ||
            (isSpace && disableSpacebarClick) ||
            (isEnter && disableEnterClick) ||
            // buttons and textareas, and inputs shouldn't be polyfilled
            /BUTTON|TEXTAREA|INPUT/.test(tagName) ||
            // native links don't click on space
            (isSpace && tagName === "A")) {
            return;
        }
        if (isSpace) {
            // prevent default behavior of page scrolling
            event.preventDefault();
        }
        // don't want parent keydown events to be triggered since this should now
        // be a "click" event instead.
        event.stopPropagation();
        event.currentTarget.click();
        // disabled since useRefCache
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return disabled ? onKeyDown : handleKeyDown;
}
//# sourceMappingURL=useKeyboardClickPolyfill.js.map